import React from 'react';
import {PageConfigTypes} from 'app/types/PageTypes';

const pagesConfigs: PageConfigTypes[] = [];
const setPagesConfigs: React.Dispatch<React.SetStateAction<PageConfigTypes[]>> = () => {};

const AppContext = React.createContext({pagesConfigs, setPagesConfigs});

export default AppContext;
